import React, { useEffect, useState } from "react";
import { ISpecialMattressProps } from "../../models/interface/ISpecialMattressProps";
import { getImageOrVideoPaths } from "../../shared/helpers";
import "./style.scss";
import _ from "lodash";
import {
  SECTION_STORE,
  TOTAL_REQUEST,
  WIDTH_HEADER,
  WIDTH_IPAD,
} from "../../common/constant";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Stores from "../stores";
import { sections } from "../../services";
import { useDispatch, useSelector } from "react-redux";
import { selectSections } from "../../redux/reducers/slice/home";
import { setIsLoading } from "../../redux/reducers/slice/common";

gsap.registerPlugin(ScrollTrigger);
interface ISpecialMattressItemsProps extends ISpecialMattressProps {
  sectionItems: any;
}

const SpecialMattressItems = (props: ISpecialMattressItemsProps) => {
  const { sectionItems, history } = props;
  const sectionsData = useSelector(selectSections);
  const dispatch = useDispatch();
  const sectionId = SECTION_STORE;
  const { innerWidth } = window;
  const [isLoaded, setIsLoaded] = useState<any>({
    "img-top_1": false,
    "img-top_2": false,
    "img-top_3": false,
    "img-middle_1": false,
    "img-middle_2": false,
    "img-middle_3": false,
    "img-middle-left_1": false,
    "img-middle-left_3": false,
    "img-bottom_1": false,
    "img-bottom_2": false,
    "img-bottom_3": false,
  });
  const [stores, setStores] = React.useState<any>(
    (sectionsData &&
      sectionsData.length &&
      sectionsData.filter((s: any) => s._id.toString() === sectionId[0])) ||
      []
  );

  const _marker = innerWidth > WIDTH_HEADER ? 160 : 120;
  const _isDesktop = innerWidth > WIDTH_IPAD;

  localStorage.setItem(TOTAL_REQUEST, "10");

  useEffect(() => {
    let st1: any,
      st2: any,
      st3: any,
      st4: any,
      st5: any,
      st6: any,
      st7: any,
      st8: any,
      st9: any;
    const el1 = document.getElementById("kd-smi-item-bottom-1");
    const el2 = document.getElementById("kd-smi-item-bottom-2");
    const el3 = document.getElementById("kd-smi-item-1");
    const el4 = document.getElementById("kd-smi-item-2");
    dispatch(setIsLoading(true));

    if (
      Object.values(isLoaded).every((item) => item) &&
      el1 &&
      el2 &&
      el3 &&
      el4
    ) {
      const _mark1 = 120;
      const _mark2 = 350;
      setTimeout(() => {
        localStorage.setItem(TOTAL_REQUEST, "0");
        dispatch(setIsLoading(false));

        st1 = gsap.from(".kd-special-mattress-items", {
          scrollTrigger: {
            trigger: "#kd-smi-item-0",
            start: `bottom ${
              _isDesktop ? "bottom" : `${el1.offsetHeight + _mark1}px`
            }`,
            end: `${
              _isDesktop ? `${el3.offsetHeight + _mark2}px` : "bottom"
            } ${_marker}px`,
            pin: true,
            pinSpacing: false,
            // markers: true,
          },
        });
        st2 = gsap.from(".kd-special-mattress-items", {
          scrollTrigger: {
            trigger: "#kd-smi-item-1",
            start: `bottom ${
              _isDesktop ? "bottom" : `${el2.offsetHeight + _mark1}px`
            }`,
            end: `${
              _isDesktop ? `${el4.offsetHeight + _mark2}px` : "bottom"
            } ${_marker}px`,
            pin: true,
            pinSpacing: false,
            // markers: true,
          },
        });
        st3 = gsap.to(".kd-special-mattress-items-item-bottom-1-left", {
          y: 0,
          opacity: 1,
          scrollTrigger: {
            trigger: ".kd-special-mattress-items-item-bottom-1-left",
            start: "-100px center",
            end: "300px center",
            scrub: true,
            // markers: true,
          },
        });
        st4 = gsap.to(".kd-special-mattress-items-item-bottom-1-right", {
          y: 0,
          opacity: 1,
          scrollTrigger: {
            trigger: ".kd-special-mattress-items-item-bottom-1-right",
            start: "-100px center",
            end: "200px center",
            scrub: true,
            // markers: true,
          },
        });
        st5 = gsap.to(".kd-special-mattress-items-item-bottom-3-left", {
          x: 0,
          opacity: 1,
          scrollTrigger: {
            trigger: ".kd-special-mattress-items-item-bottom-3-left",
            start: "-300px center",
            end: "0px center",
            scrub: true,
            // markers: true,
          },
        });
        st6 = gsap.to(".kd-special-mattress-items-item-bottom-3-right", {
          opacity: 1,
          scrollTrigger: {
            trigger: ".kd-special-mattress-items-item-bottom-3-right",
            start: "-50px center",
            end: "400px center",
            scrub: true,
            // markers: true,
          },
        });
        st7 = gsap.to("#kd-smi-item-title-1", {
          opacity: 1,
          scrollTrigger: {
            trigger: "#kd-smi-item-title-1",
            start: "-200px center",
            end: "200px center",
            scrub: true,
            // markers: true,
          },
        });
        st8 = gsap.to("#kd-smi-item-title-2", {
          opacity: 1,
          scrollTrigger: {
            trigger: "#kd-smi-item-title-2",
            start: "-200px center",
            end: "200px center",
            scrub: true,
            // markers: true,
          },
        });
        st9 = gsap.to("#kd-smi-item-title-3", {
          opacity: 1,
          scrollTrigger: {
            trigger: "#kd-smi-item-title-3",
            start: "-200px center",
            end: "200px center",
            scrub: true,
            // markers: true,
          },
        });
      }, 1000);
    }

    return () => {
      localStorage.setItem(TOTAL_REQUEST, "0");
      if (st1 && st2 && st3 && st4 && st5 && st6 && st7 && st8 && st9) {
        st1.scrollTrigger.kill();
        st2.scrollTrigger.kill();
        st3.scrollTrigger.kill();
        st4.scrollTrigger.kill();
        st5.scrollTrigger.kill();
        st6.scrollTrigger.kill();
        st7.scrollTrigger.kill();
        st8.scrollTrigger.kill();
        st9.scrollTrigger.kill();
      }
    };
  }, [isLoaded]);

  useEffect(() => {
    if (!stores.length) {
      sections.getSections({ ids: sectionId }, (data: any, err: any) => {
        if (data && data.data && data.data.length) {
          setStores(data.data);
        }
      });
    }
  }, []);

  const handleClick = (e: any, url: string = "") => {
    e.preventDefault();
    history.push(url);
  };

  const renderItems = (data: any) =>
    _.sortBy(data, ["order"]).map((item: any, index: number) => {
      const imgs = getImageOrVideoPaths(item.images);
      const subImgs = getImageOrVideoPaths(item.sub_images);

      return (
        <div
          className="kd-special-mattress-items-item"
          id={`kd-smi-item-${index}`}>
          <div className="kd-special-mattress-items-item-top">
            <div
              className={`kd-special-mattress-items-item-top-title`}
              id={`kd-smi-item-title-${item.order}`}>
              <img src={imgs[0]} alt="" />
            </div>
            <div className="kd-special-mattress-items-item-top-img">
              <img
                src={imgs[1]}
                alt=""
                onLoad={() =>
                  setIsLoaded({ ...isLoaded, [`img-top_${item.order}`]: true })
                }
              />
            </div>
          </div>
          <div
            className="kd-special-mattress-items-item-bottom"
            id={`kd-smi-item-bottom-${item.order}`}>
            <div
              className={`kd-special-mattress-items-item-bottom-${item.order}`}>
              <div
                className={`kd-special-mattress-items-item-bottom-${item.order}-img`}>
                <img
                  src={imgs[2]}
                  alt=""
                  onLoad={() =>
                    setIsLoaded({
                      ...isLoaded,
                      [`img-middle_${item.order}`]: true,
                    })
                  }
                />
              </div>
              {item.order != 2 ? (
                <React.Fragment>
                  <div
                    className={`kd-special-mattress-items-item-bottom-${item.order}-left`}>
                    <img
                      src={imgs[3]}
                      alt=""
                      onLoad={() =>
                        setIsLoaded({
                          ...isLoaded,
                          [`img-middle-left_${item.order}`]: true,
                        })
                      }
                    />
                  </div>
                  <div
                    className={`kd-special-mattress-items-item-bottom-${item.order}-right`}>
                    <img src={imgs[4]} alt="" />
                  </div>
                </React.Fragment>
              ) : null}
            </div>
            <div className="kd-special-mattress-items-item-bottom-img">
              <img
                src={item.order != 2 ? imgs[5] : imgs[3]}
                alt=""
                onLoad={() =>
                  setIsLoaded({
                    ...isLoaded,
                    [`img-bottom_${item.order}`]: true,
                  })
                }
              />
              <div
                className={`kd-special-mattress-items-item-action action-${item.order}`}
                onClick={(e) => handleClick(e, item.url)}>
                <img src={subImgs[0]} alt="" />
              </div>
            </div>
          </div>
        </div>
      );
    });

  return (
    <div className="kd-special-mattress-items">
      {sectionItems.length ? renderItems(sectionItems) : null}
      {Object.values(isLoaded).every((item) => item) ? (
        <Stores history={history} sectionItem={stores[0]} />
      ) : null}
    </div>
  );
};

export default SpecialMattressItems;
